<script type="text/javascript">
import {
  VFileInput,
  VTextField,
  VTextarea,
  VSelect,
  VCheckbox,
  VDatePicker,
  VTimePicker,
  VRadioGroup,
  VSwitch,
  VPicker
} from 'vuetify/lib'

var FieldTypeDictionary = {
  'String': 'v-text-field',
  'Int': 'v-text-field',
  'Int16': 'v-text-field',
  'Double': 'v-text-field',
  'Decimal': 'v-text-field',
  'Boolean': 'v-switch',
  'Bool': 'v-switch',
  'Datetime': 'app-datetime-picker',
  'DateTime': 'app-datetime-picker',
  'list': 'v-select',
  'Date':'app-datetime-picker',
  'Array':'app-array-field',
}
var TypeDictionary = {
  'String': 'text',
  'Int': 'number',
  'Int16': 'number',
  'Double': 'number',
  'Decimal': 'number',
  'Boolean': 'checkbox',
  'Bool': 'checkbox',
  'Datetime': 'text',
  'DateTime': 'text',
  'list': 'text',
  'Date': 'text',
  'Array': 'text',
}

export default {
  Name: 'FooField',
  components: {
    VFileInput,
    VTextField,
    VTextarea,
    VSelect,
    VCheckbox,
    VDatePicker,
    VTimePicker,
    VRadioGroup,
    VSwitch,
    VPicker
  },
  props: [
    'type',
    'field',
    'entity',
    'checked',
    'errorMessages',
    'value',
    'label',
  ],
  methods: {
    /*
    Returns true if any of the rules given in a field are required, verifying that the field is extra
    */
    isRequiredExtraField(field){
      let isRequired = false;
      const requiredFieldRegex = /^((\x\s\=\>\s\x\.)(\b(GetExtraDataValue)\b)(\(\")([\s\S]+)(\"\))(\s\!\=\s))(\b(null)\b)$/
      if(field.extra && field.rules.length > 0){
        field.rules.forEach(rule => {
          if(requiredFieldRegex.test(rule.expression)){
            isRequired = true;
          }
        });
      }
      return isRequired;
    },
    getElementTagName(type) {
      return FieldTypeDictionary[type]
    },
    /*
    Get error key to get the message from store.state.errors
    Try to get it with ucfirst(), if it is undefined, try without ucfisrt
    */
    getErrorKey(){
      return null;
      // var errorKey = Object.keys(this.$store.state.errors).find(k => k.includes('.' + this.$ucfirst(this.field && this.field.name)))
      // if(!errorKey){
      //   errorKey = Object.keys(this.$store.state.errors).find(k => k.includes('.' + this.field && this.field.name))
      // }
      // return errorKey;
    },
    getVueNodeAttributes () {
      var t = this
      return {
        class: {
          ['foo-field']: true,
        },
        props: {
          ...this.$vnode.data.attrs,
          errorMessages: this.$store.state.errors[this.getErrorKey()] || this.errorMessages,
          label: (this.field ? this.isRequiredExtraField(this.field) : false) ? this.$camelToString(this.label) + '*' : this.$camelToString(this.label),
          type: TypeDictionary[this.type],
          disableTime: this.$vnode.data.attrs.disableTime || (this.type == 'Date' ? true : false),
          value: t.value,
        },
        attrs: {
          ...this.$vnode.data.attrs,
          type: TypeDictionary[t.type],
          checked: t.checked,
        },
        domProps: {
          type: TypeDictionary[t.type],
          checked: t.checked
        },
        on: {
          ...this._events,
        }
      }
    }
  },
  render: function (h) {
    return h(
      this.getElementTagName(this.type),
      this.getVueNodeAttributes(),
      this.$slots.default
    )
  }
}
</script>

<style lang="scss" scoped>
.foo-field {
  // ::v-deep fieldset {
  //   height: 32px;
  // }
  ::v-deep .v-input__slot{
    min-height: 32px !important;
  }
}
</style>
